import React, { useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { useSearchTerm } from '../hooks/useSearchTerm';
import { useSyncPageParams } from '../hooks/useSyncPageParams';
import { useClampPage } from '../hooks/useClampPage';
import { useGetAllEmailTemplate } from '../services/react-query/email_templates';
import { Loading } from '../uikit';
import { EmailTemplate } from '../types/EmailTemplate';
import AppLink from '../components/common/AppLink/AppLink';
import StickyTableHeader from '../components/common/StickyTableHeader';
import { ROUTE_PATHS } from '../routes/Routes';
import ListHeader from '../components/listHeader/ListHeader';
import FilterSidebar from '../components/common/filters/FilterSidebar';
import { UserConfigurableModule } from '../types/User';
import { archiveFilter } from '../components/common/filters/consts';
import { FilterState, IFilter } from '../components/common/filters/interfaces';
import {
  defaultContainerStyling,
  listPageLayoutStyles,
  listPageTableRowStyling,
  listPageTableWrapperStyles,
} from '../styles/sxStyling';
import ListBottomBar from '../components/common/ListBottomBar/ListBottomBar';

const EmailTemplatesList: React.FC = () => {
  const { currentPage, setCurrentPage } = useSyncPageParams();
  const [filterState, setFilterState] = useState<FilterState>(undefined);
  const { data, isLoading } = useGetAllEmailTemplate({
    params: {
      page: currentPage,
      search: useSearchTerm(),
      filters: filterState,
    },
    enabled: true,
  });

  useClampPage(currentPage, data?.meta?.total_pages, setCurrentPage);

  if (isLoading) return <Loading />;

  const templates: EmailTemplate[] = data?.data || [];
  const meta = data?.meta;
  const moduleFilters: IFilter[] = [archiveFilter];
  const headerCells = ['Name', 'Subject', 'Description'];

  return (
    <Box>
      <ListHeader title="Email Templates" />

      <Box sx={listPageLayoutStyles}>
        <FilterSidebar
          moduleFilters={moduleFilters}
          module={UserConfigurableModule.EMAIL_TEMPLATES}
          activeFilter={filterState}
          setActiveFilter={setFilterState}
        />

        <Box sx={listPageTableWrapperStyles}>
          <TableContainer sx={defaultContainerStyling}>
            <Table>
              <StickyTableHeader cells={headerCells} />
              <TableBody>
                {templates.map((template) => (
                  <TableRow key={template.uuid} sx={{ ...listPageTableRowStyling }}>
                    <TableCell>
                      <AppLink to={`/${ROUTE_PATHS.EMAIL_TEMPLATES}/${template.uuid}`}>{template.name}</AppLink>
                    </TableCell>
                    <TableCell>{template.subject}</TableCell>
                    <TableCell>{template.description}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <ListBottomBar page={currentPage} meta={meta} onChange={(_e, v) => setCurrentPage(v)} />
        </Box>
      </Box>
    </Box>
  );
};

export default EmailTemplatesList;
